module.exports = function () { return null }



//////////////////
// WEBPACK FOOTER
// ./~/empty-functions/returns-null.js
// module id = 23
// module chunks = 0